export default __webpack_public_path__ + "static/media/grafema_packaging-cale-do-oiro_06.3e33f1d4.jpg";